import styled from '@emotion/styled';
import { Column, FormTitle, Row, useMedia, typography } from '@landsbankinn/ui';
import * as React from 'react';
import { DatepickerWithCheckmark } from '../icons/DatepickerWithCheckmark';

const Text = styled.p`
  ${typography.body}
  margin-bottom: ${(props) => props.theme.baseline * 7}px;
`;

const SecoundText = styled.p`
  ${typography.body}
  margin-bottom: ${(props) => props.theme.baseline * 10}px;
`;

const SvgColumn = styled(Column)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Icon = styled(DatepickerWithCheckmark)`
  width: 100%;
`;

export function GdprSuccess() {
  const isDesktop = useMedia('lg');

  return (
    <>
      <Row>
        <Column
          sm={{ width: 12 / 12 }}
          md={{ width: 10 / 12, offset: 1 / 12 }}
          lg={{ width: 5 / 12, offset: 1 / 12 }}
        >
          <FormTitle text="Beiðnin hefur verið móttekin" />

          <Row>
            <Column sm={{ width: 12 / 12 }} lg={{ width: 9.8 / 12 }}>
              <Text>
                Landsbankinn hefur móttekið beiðni þína og mun nú hefjast handa
                við að afgreiða beiðnina.
              </Text>
              <SecoundText>
                Landsbankinn leitast við að svara öllum beiðnum innan 30 daga en
                eftir atvikum gæti afgreiðsla erinda tafist í ljósi stærðar og
                umfangs starfsemi bankans. Ef svo er verður þú upplýst(ur) um
                fyrirhugaða töf og ástæður hennar.
              </SecoundText>
            </Column>
          </Row>
        </Column>
        {isDesktop && (
          <SvgColumn md={{ width: 5 / 12 }} lg={{ width: 6 / 12 }}>
            <Icon />
          </SvgColumn>
        )}
      </Row>
    </>
  );
}
